import type { TransformMetadataResult } from '@post-office/message-template-contracts/message-template-metadata';

import {
	type AnyPayload,
	type BackendSyncMessageStage,
} from '../../../../../create-placement/types';

export const defaultTransformMetadata: BackendSyncMessageStage<
	AnyPayload,
	TransformMetadataResult
> = () => ({
	goalMetadata: {
		primaryGoal: {
			goalId: 'clickthrough',
		},
	},
});
